module.exports = __webpack_public_path__ + "img/img_footer_instagram.162ea88c.png";